import * as React from 'react';
import { AlchemyResult } from '../../../models/apiModels';
import { SelfHelpIntentGraphContainer } from '../containerComponents/SelfHelpIntentGraphContainer';

interface IUnAuthIntentGraphProps {
  isUnauthSchemaFetching: boolean;
  unAuthSignInResult: AlchemyResult
  showUnAuthBranching: boolean;
}

export const UnAuthIntentGraph = (props: IUnAuthIntentGraphProps) => {
    if (
      props.showUnAuthBranching &&
      props.unAuthSignInResult
    ) {
      const correlationId = props.unAuthSignInResult.CorrelationId;
      return (
        <SelfHelpIntentGraphContainer
          graphInsights={props.unAuthSignInResult.Insights}
          areaName={'modalitiesSection'}
          correlationId={correlationId}
          key={correlationId}
        />
      );
    } else if (props.isUnauthSchemaFetching) {
      return null;
    } else {
      return null;
    }
};
